import "./index.css";
import { clsx } from "clsx";
import { CalendarContext } from "./context";
import { Days } from "./Days";
import { Header } from "./Header";
import { Months } from "./Months";
import type { ICalendarProps } from "./types";
import { CalendarView } from "./types";
import { useViewModel } from "./useViewModel";
import { Years } from "./Years";

export const Calendar = (props: ICalendarProps) => {
  const context = useViewModel(props);

  return (
    <CalendarContext value={context}>
      <div
        ref={context.rootRef}
        tabIndex={-1}
        className={clsx("nuco-calendar nuco-color-brand", props.className)}
      >
        <Header />
        {context.view === CalendarView.Days && <Days />}
        {context.view === CalendarView.Months && <Months />}
        {context.view === CalendarView.Years && <Years />}
      </div>
    </CalendarContext>
  );
};
